import React, { useEffect, useState } from "react";
import DashboardLayout from "./dashboardLayout";
import DashboardSuperAdmin from "./superadmin/superadmin";
import DashboardSecretaria from "./secretaria/secretaria";
import AdministradorDashboard from "./administrador/pages/AdministradorDashboard";
import CajeroDashboard from "./cajero/pages/CajeroDashboard";
import RecepcionistaDashboard from "./recepcionista/pages/RecepcionistaDashboard";

export default function ViewDashboard() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    if (!user) return <div className="text-center p-5">Cargando...</div>;

    switch (user.rol?.nombre?.toLowerCase()) {
        case "superadmin":
            return <DashboardSuperAdmin user={user} />;
        case "recepcionista":
            return <RecepcionistaDashboard user={user} />;
        case "secretaria":
            return <DashboardSecretaria user={user} />;
        case "cajero":
            return <CajeroDashboard user={user} />;
        case "coordinador":
        case "docente":
        case "administrador":
            return <AdministradorDashboard user={user} />;
        default:
            return <DashboardLayout user={user} />;
    }
}
